import { render } from "./ShoppingListXl.vue?vue&type=template&id=57cbc5d9"
import script from "./ShoppingListXl.vue?vue&type=script&lang=js"
export * from "./ShoppingListXl.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__